import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Container from "../primitives/Container";
import Wordmark from "./Wordmark";
import MenuOverlay from "./MenuOverlay";

/**
 * Nav — permanent navy header. One architectural element across the entire site.
 * Height, background, and typography are pixel-identical on every page and every
 * scroll position. Only the menu overlay open/close affects state.
 */
export const Nav = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close the menu on route change (safety — the menu itself calls onClose on nav)
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header
        data-testid="site-nav"
        data-section-tone="dark"
        data-cursor-scheme="dark"
        className="fixed top-0 inset-x-0 z-[60] bg-navy border-b border-offwhite/5"
      >
        <Container className="flex items-center justify-between h-16 sm:h-20">
          <Wordmark tone="dark" />

          <button
            type="button"
            data-testid="menu-trigger"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            className="group inline-flex items-center gap-3 font-sans uppercase text-offwhite/85 hover:text-offwhite transition-colors duration-300"
            style={{ fontSize: "11px", letterSpacing: "0.22em" }}
          >
            <span className="relative">
              Menu
              <span
                aria-hidden="true"
                className="absolute left-0 right-0 -bottom-1 h-px bg-gold scale-x-0 origin-left group-hover:scale-x-100 transition-transform duration-300 ease-out"
              />
            </span>
            <span
              aria-hidden="true"
              className="relative inline-block"
              style={{ width: 14, height: 10 }}
            >
              <span
                className="absolute left-0 right-0 h-px bg-current"
                style={{
                  top: open ? "50%" : "20%",
                  transform: open ? "translateY(-50%) rotate(45deg)" : "none",
                  transition:
                    "top 350ms cubic-bezier(0.16,1,0.3,1), transform 350ms cubic-bezier(0.16,1,0.3,1)",
                }}
              />
              <span
                className="absolute left-0 right-0 h-px bg-current"
                style={{
                  top: open ? "50%" : "80%",
                  transform: open ? "translateY(-50%) rotate(-45deg)" : "none",
                  transition:
                    "top 350ms cubic-bezier(0.16,1,0.3,1), transform 350ms cubic-bezier(0.16,1,0.3,1)",
                }}
              />
            </span>
          </button>
        </Container>
      </header>

      <MenuOverlay open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default Nav;
